import $ from 'jquery';
import React, {Component} from 'react';
import {Dummy, Tank, Status, StatusBA} from '../';
import styles from './style.css';
import * as trends from '../../../trends.js';

export default class Mainentry extends Dummy {

    render() {

        return (
            <div className={styles.main + ' ' + 'row'}>
                <div className={'col-md-2' + ' ' + styles.lightgreenBorder}>
                    
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title}>&nbsp;<br/>Режим работы</th>
                            </tr>
                            <tr>
                                <Status ps={['tc_6_127_100']} zeroText="Лето" oneText="Зима"
                                        zeroClass={styles.statusSummer} oneClass={styles.statusWinter} {...this.props}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title}>ЦП АСМУ</th>
                            </tr>
                            <tr>
                                <Status ps={['tc_6_-1_92']} zeroText="Есть связь" oneText="Нет связи"
                                        zeroClass={styles.statusConnOk} oneClass={styles.statusConnBad} {...this.props}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title}>Котел ЕК-1</th>
                            </tr>
                            <tr>
                                <Status ps={['tc_6_112_0']} zeroText="Есть связь" oneText="Нет связи"
                                        zeroClass={styles.statusConnOk} oneClass={styles.statusConnBad} {...this.props}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title}>Котел ЕК-2</th>
                            </tr>
                            <tr>
                                <Status ps={['tc_6_118_0']} zeroText="Есть связь" oneText="Нет связи"
                                        zeroClass={styles.statusConnOk} oneClass={styles.statusConnBad} {...this.props}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title}>Котел ЕК-3</th>
                            </tr>
                            <tr>
                                <Status ps={['tc_6_115_0']} zeroText="Есть связь" oneText="Нет связи"
                                        zeroClass={styles.statusConnOk} oneClass={styles.statusConnBad} {...this.props}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title}>Модуль А1</th>
                            </tr>
                            <tr>
                                <Status ps={['tc_6_96_0']} zeroText="Есть связь" oneText="Нет связи"
                                        zeroClass={styles.statusConnOk} oneClass={styles.statusConnBad} {...this.props}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title}>Модуль А2</th>
                            </tr>
                            <tr>
                                <Status ps={['tc_6_97_0']} zeroText="Есть связь" oneText="Нет связи"
                                        zeroClass={styles.statusConnOk} oneClass={styles.statusConnBad} {...this.props}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title}>Счетчик PI1</th>
                            </tr>
                            <tr>
                                <Status ps={['tc_6_93_0']} zeroText="Есть связь" oneText="Нет связи"
                                        zeroClass={styles.statusConnOk} oneClass={styles.statusConnBad} {...this.props}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title}>Счетчик QI1</th>
                            </tr>
                            <tr>
                                <Status ps={['tc_6_94_0']} zeroText="Есть связь" oneText="Нет связи"
                                        zeroClass={styles.statusConnOk} oneClass={styles.statusConnBad} {...this.props}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                
                 

                </div>
               
                <div className={'col-md-2' + ' ' + styles.blueBorder}>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title} colSpan="2">Расход воды:<br/>через нагрузку</th>
                            </tr>
                            <tr>
                                <th className={styles.caption}>Q м3/ч</th>
                                {this.getPsValue('ti_6_94_25', 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title} colSpan="2">через ТО</th>
                            </tr>
                            <tr>
                                <th className={styles.caption}>Q м3/ч</th>
                                {this.getPsValue('ti_6_94_26', 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title}>Бак аккумулятор:<br/> уровень воды</th>
                            </tr>
                            <tr>
                            <StatusBA {...this.props} ps={['tc_6_96_501', 'tc_6_96_502','tc_6_96_500']}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title}>уровень заряда</th>
                            </tr>
                            <tr>
                            <Status ps={['tc_6_96_110']} zeroText="Низкий" oneText="В норме"
                                        zeroClass={styles.statusAvar} oneClass={styles.statusNorm} {...this.props}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                     <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title}>&nbsp;<br/>Насос Н1</th>
                            </tr>
                            <tr>
                                <Status ps={['tc_6_96_101']} zeroText="В норме" oneText="Авария"
                                        zeroClass={styles.statusNorm} oneClass={styles.statusAvar} {...this.props}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title}>Насос Н2</th>
                            </tr>
                            <tr>
                                <Status ps={['tc_6_96_102']} zeroText="В норме" oneText="Авария"
                                        zeroClass={styles.statusNorm} oneClass={styles.statusAvar} {...this.props}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title}>Насос Н3</th>
                            </tr>
                            <tr>
                                <Status ps={['tc_6_118_16']} zeroText="В норме" oneText="Авария"
                                        zeroClass={styles.statusNorm} oneClass={styles.statusAvar} {...this.props}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title}>Давление воды<br/>в системе отопления</th>
                            </tr>
                            <tr>
                                <Status ps={['tc_6_97_16']} zeroText="В норме" oneText="Авария"
                                        zeroClass={styles.statusNorm} oneClass={styles.statusAvar} {...this.props}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                </div>


                <div className={styles.purpleBorder + ' ' + 'col-md-2'}>
                            <div className="row">
                                <table className={styles.tg}>
                                    <tbody>
                                    <tr>
                                        <th className={styles.title} colSpan="2">Т наружного воздуха</th>
                                    </tr>
                                    <tr>
                                        <th className={styles.caption}>T °C</th>
                                        {this.getPsValue('ti_6_96_1', 'th', styles.disabled, styles.value)}
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="row">
                                <table className={styles.tg}>
                                    <tbody>
                                    <tr>
                                        <th className={styles.title} colSpan="2">Т в БА</th>
                                    </tr>
                                    <tr>
                                        <th className={styles.caption}>T °C</th>
                                        {this.getPsValue('ti_6_96_4', 'th', styles.disabled, styles.value)}
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="row">
                                <table className={styles.tg}>
                                    <tbody>
                                    <tr>
                                        <th className={styles.title} colSpan="2">Т на нагрузке</th>
                                    </tr>

                                    <tr>
                                        <th className={styles.subtitle}></th>
                                        <th className={styles.subtitle}>T °C</th>
                                    </tr>
                                    <tr>
                                        <th className={styles.caption}>Подача</th>
                                        {this.getPsValue('ti_6_94_7', 'th', styles.disabled, styles.value)}
                                    </tr>

                                    <tr>
                                        <th className={styles.caption}>Обратка</th>
                                        {this.getPsValue('ti_6_94_8', 'th', styles.disabled, styles.value)}
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="row">
                                <table className={styles.tg}>
                                    <tbody>
                                    <tr>
                                         <th className={styles.title} colSpan="2">Т на теплообменнике</th>
                                    </tr>
                                    <tr>
                                        <th className={styles.subtitle}></th>
                                        <th className={styles.subtitle}>T °C</th>
                                    </tr>
                                      <tr>
                                        <th className={styles.caption}>Подача</th>
                                        {this.getPsValue('ti_6_96_3', 'th', styles.disabled, styles.value)}
                                    </tr>
                                    <tr>
                                        <th className={styles.caption}>Обратка</th>
                                        {this.getPsValue('ti_6_96_6', 'th', styles.disabled, styles.value)}
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            
                            <div className="row">
                                <table className={styles.tg}>
                                    <tbody>
                                    <tr>
                                        <th className={styles.title}>Котел ЕК-1</th>
                                    </tr>
                                    <tr>
                                        <Status ps={['tc_6_112_400']} zeroText="В норме" oneText="Авария"
                                                zeroClass={styles.statusNorm} oneClass={styles.statusAvar} {...this.props}/>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="row">
                                <table className={styles.tg}>
                                    <tbody>
                                    <tr>
                                        <th className={styles.title}>Котел ЕК-2</th>
                                    </tr>
                                    <tr>
                                        <Status ps={['tc_6_118_400']} zeroText="В норме" oneText="Авария"
                                                zeroClass={styles.statusNorm} oneClass={styles.statusAvar} {...this.props}/>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="row">
                                <table className={styles.tg}>
                                    <tbody>
                                    <tr>
                                        <th className={styles.title}>Котел ЕК-3</th>
                                    </tr>
                                    <tr>
                                        <Status ps={['tc_6_115_400']} zeroText="В норме" oneText="Авария"
                                                zeroClass={styles.statusNorm} oneClass={styles.statusAvar} {...this.props}/>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="row">
                                <table className={styles.tg}>
                                    <tbody>
                                    <tr>
                                        <th className={styles.title} colSpan="2">Т подачи с котла</th>
                                    </tr>
                                    <tr>
                                        <th className={styles.caption}>T °C</th>
                                        {this.getPsValue('ti_6_94_9', 'th', styles.disabled, styles.value)}
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                 </div> 

                <div className={'col-md-2' + ' ' + styles.grayBorder}>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title}>Ввод №1</th>
                            </tr>
                            <tr>
                                <Status ps={['tc_6_97_3']} zeroText="Авария" oneText="В норме"
                                        zeroClass={styles.statusAvar} oneClass={styles.statusNorm} {...this.props}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title}>Ввод №2</th>
                            </tr>
                            <tr>
                                <Status ps={['tc_6_97_4']} zeroText="Авария" oneText="В норме"
                                        zeroClass={styles.statusAvar} oneClass={styles.statusNorm} {...this.props}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title} colSpan="3">Мгновенные показатели</th>
                            </tr>
                            <tr>
                                <th className={styles.subtitle}></th>
                                <th className={styles.subtitle}>U(B)</th>
                                <th className={styles.subtitle}>I(A)</th>

                            </tr>
                            <tr>
                                <th className={styles.caption}>Фаза А</th>
                                {this.getPsValue('ti_6_93_141', 'th', styles.disabled, styles.value)}
                                {this.getPsValue('ti_6_93_151', 'th', styles.disabled, styles.value)}

                            </tr>
                            <tr>
                                <th className={styles.caption}>Фаза B</th>
                                {this.getPsValue('ti_6_93_142', 'th', styles.disabled, styles.value)}
                                {this.getPsValue('ti_6_93_152', 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>Фаза C</th>
                                {this.getPsValue('ti_6_93_143', 'th', styles.disabled, styles.value)}
                                {this.getPsValue('ti_6_93_153', 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}></th>
                                <th className={styles.caption}>W(кВт)</th>
                                <th className={styles.caption}>Q(кВар)</th>

                            </tr>
                            <tr>
                                <th className={styles.caption}>Фаза А</th>
                                {this.getPsValue('ti_6_93_101', 'th', styles.disabled, styles.value)}
                                {this.getPsValue('ti_6_93_121', 'th', styles.disabled, styles.value)}

                            </tr>
                            <tr>
                                <th className={styles.caption}>Фаза B</th>
                                {this.getPsValue('ti_6_93_102', 'th', styles.disabled, styles.value)}
                                {this.getPsValue('ti_6_93_122', 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>Фаза C</th>
                                {this.getPsValue('ti_6_93_103', 'th', styles.disabled, styles.value)}
                                {this.getPsValue('ti_6_93_123', 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title} colSpan="2">Накопительные показатели</th>
                            </tr>
                            <tr>
                                <th className={styles.subtitle}></th>
                                <th className={styles.subtitle}>Энергия</th>
                            </tr>
                            <tr>
                                <th className={styles.caption}>W(кВт*ч)</th>
                                {this.getPsValue('ti_6_93_1', 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>T1 W(кВт*ч</th>
                                {this.getPsValue('ti_6_93_2', 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>T2 W(кВт*ч</th>
                                {this.getPsValue('ti_6_93_3', 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>T3 W(кВт*ч</th>
                                {this.getPsValue('ti_6_93_4', 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>Q(кВар*ч)</th>
                                {this.getPsValue('ti_6_93_21', 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className={'col-md-2' + ' ' + styles.lightblueBorder}>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title} colSpan="4">Статистика<br/>потребления Э/Э</th>
                            </tr>
                            <tr>
                                <th className={styles.subtitle}></th>
                                <th className={styles.subtitle}>кВт*ч</th>
                            </tr>
                            <tr>
                                <th className={styles.caption}>Сутки пр.</th>
                                {this.getPsValue('ti_6_126_11', 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>Сутки ус.</th>
                                {this.getPsValue('ti_6_126_14', 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>Сезон тк.</th>
                                {this.getPsValue('ti_6_126_41', 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>Сезон пр.</th>
                                {this.getPsValue('ti_6_126_48', 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>Весь период</th>
                                {this.getPsValue('ti_6_126_34', 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title} colSpan="4">Статистика<br/>генерации Т/Э</th>
                            </tr>
                            <tr>
                                <th className={styles.subtitle}></th>
                                <th className={styles.subtitle}>Гкал</th>
                            </tr>
                            <tr>
                                <th className={styles.caption}>Сутки пр.</th>
                                {this.getPsValue('ti_6_126_12', 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>Сутки ус.</th>
                                {this.getPsValue('ti_6_126_15', 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>Сезон тк.</th>
                                {this.getPsValue('ti_6_126_42', 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>Сезон пр.</th>
                                {this.getPsValue('ti_6_126_49', 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>Весь период</th>
                                {this.getPsValue('ti_6_126_35', 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className={'col-md-2' + ' ' + styles.lightgreenBorder}>
                    
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title} colSpan="2">Мощность генерации<br/>за прошедший час</th>
                            </tr>
                            <tr>
                                <th className={styles.caption}>Рпг (кВт)</th>
                                {this.getPsValue('ti_6_127_2', 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title} colSpan="2">Мощность потерь<br/>за прошедший час</th>
                            </tr>
                            <tr>
                                <th className={styles.caption}>Рпп (кВт)</th>
                                {this.getPsValue('ti_6_127_8', 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={styles.title} colSpan="2">Мощность потребления<br/>за прошедший час</th>
                            </tr>
                            <tr>
                                <th className={styles.caption}>Рпн (кВт)</th>
                                {this.getPsValue('ti_6_127_4', 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                    <table className={styles.tg}>
                        <tbody>
                        <tr>
                            <th className={styles.title} colSpan="2">Показатели бака</th>
                        </tr>
                        <tr>
                            <th className={styles.caption}>Тз (часов)</th>
                            {this.getPsValue('ti_6_127_9', 'th', styles.disabled, styles.value)}
                        </tr>
                        <tr>
                            <th className={styles.caption}>Wз (кВт*ч)</th>
                            {this.getPsValue('ti_6_127_5', 'th', styles.disabled, styles.value)}
                        </tr>
                        <tr>
                            <th className={styles.caption}>Wд (кВт*ч)</th>
                            {this.getPsValue('ti_6_127_6', 'th', styles.disabled, styles.value)}
                        </tr>
                        </tbody>
                    </table>
                </div>
                </div>

                

            </div>
        
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/entries/Mainentry/index.jsx